import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CardItem } from './new-internet.model';

@Component({
    selector: 'app-ni-feed-item',
    templateUrl: './feed-item.component.html',
    styleUrls: ['./feed-item.component.scss'],
    standalone: false
})
export class FeedItemComponent {
  @Input() item!: CardItem;
  @Output() open = new EventEmitter<void>();
  @Output() toggleLike = new EventEmitter<void>();

  expanded = false;

  toggleExpand(): void {
    this.expanded = !this.expanded;
    if (this.expanded) { this.open.emit(); }
  }

  // For YouTube items, derive an embeddable URL from the watch link.
  get youtubeEmbed(): string | null {
    if (this.item.sourceType !== 'youtube') { return null; }
    const m = this.item.link.match(/[?&]v=([\w-]+)/)
      || this.item.link.match(/youtu\.be\/([\w-]+)/);
    return m ? 'https://www.youtube.com/embed/' + m[1] : null;
  }
}
